import React, { useEffect, useState } from "react";
import "./wishlist.css";
import { Col, Container, Row } from "react-bootstrap";
import PaymentHeading from "../PaymentHeading/PaymentHeading";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notify } from "../ToastComponent";
import Navbar from "../Navbar/NavbarComp";
import { useTranslation } from "react-i18next";
import {
  deleteUserWishlistItem,
  getUserWishlist,
  postCartItem,
} from "../../Utilies/gamerClubApi";

const WishList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  // get user id
  let userId = JSON.parse(localStorage.getItem("user_id"));
  // get user token
  const token = localStorage.getItem("token");

  // get user cart items
  async function getWishlist(token) {
    try {
      let result = await getUserWishlist(token);
      setCart(result.data);
    } catch (error) {
      console.log(error);
    }
  }

  // delete wishlist item function
  async function deleteWishListItem(voucherId, token) {
    try {
      setCart(cart.filter((item) => item.id !== voucherId));
      await deleteUserWishlistItem(voucherId, token);
      notify("Your Item Deleted Successfully");
    } catch (error) {}
  }

  // add to cart
  async function addToCart(sectionType, token, productId, cartItemType) {
    try {
      let formData = {
        items: [
          {
            object_id: productId,
            qty: 1,
            type: cartItemType,
          },
        ],
      };
      const result = await postCartItem(formData, sectionType, token);
      console.log(result);
      notify("Your Item Added Successfully");
    } catch (error) {}
  }

  useEffect(() => {
    getWishlist(token);
  }, [token]);

  return (
    <>
      <Navbar title={t("wishlist")} />
      <Container style={{ paddingTop: "150px" }}>
        <div className="wishList">
          <div className="list-content">
            <ToastContainer />
            <PaymentHeading
              title={t("wishlist")}
              token={token}
              userId={userId}
            />
            <hr />
            <div className="table">
              {cart.length > 0 ? (
                cart.map((cartItem) => (
                  <div className="mb-3 game-row" key={cartItem.voucher.id}>
                    <Row>
                      <Col xs={12} md={6} lg={6}>
                        <div className="game-infos">
                          <img
                            src={
                              cartItem[cartItem.type].icon
                                ? cartItem[cartItem.type].icon
                                : cartItem[cartItem.type].productImage
                            }
                            alt="img"
                          />
                          <p>
                            {cartItem[cartItem.type].title}
                            {cartItem[cartItem.type].name}
                            {cartItem[cartItem.type].productName}
                          </p>
                        </div>
                      </Col>
                      <Col xs={5} md={3} lg={3}>
                        <p className="game-price">
                          {cartItem[cartItem.type]?.sellPrice
                            ? cartItem[cartItem.type]?.sellPrice
                            : cartItem[cartItem.type].price * cartItem.qty}{" "}
                          {cartItem[cartItem.type].currency}{" "}
                          {cartItem[cartItem.type].productCurrency}
                        </p>
                      </Col>
                      <Col xs={7} md={3} lg={3} className="p-0">
                        <div className="add">
                          <button
                            onClick={() =>
                              addToCart(
                                "cart",
                                token,
                                cartItem.object_id,
                                cartItem.type
                              )
                            }
                            className="qty-inp"
                          >
                            {t("add to cart")}
                          </button>
                          <button
                            className="tooltipp"
                            onClick={() =>
                              deleteWishListItem(cartItem.id, token)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 20"
                              height={25}
                              width={25}
                            >
                              <path
                                fill="#6361D9"
                                d="M8.78842 5.03866C8.86656 4.96052 8.97254 4.91663 9.08305 4.91663H11.4164C11.5269 4.91663 11.6329 4.96052 11.711 5.03866C11.7892 5.11681 11.833 5.22279 11.833 5.33329V5.74939H8.66638V5.33329C8.66638 5.22279 8.71028 5.11681 8.78842 5.03866ZM7.16638 5.74939V5.33329C7.16638 4.82496 7.36832 4.33745 7.72776 3.978C8.08721 3.61856 8.57472 3.41663 9.08305 3.41663H11.4164C11.9247 3.41663 12.4122 3.61856 12.7717 3.978C13.1311 4.33745 13.333 4.82496 13.333 5.33329V5.74939H15.5C15.9142 5.74939 16.25 6.08518 16.25 6.49939C16.25 6.9136 15.9142 7.24939 15.5 7.24939H15.0105L14.2492 14.7095C14.2382 15.2023 14.0377 15.6726 13.6883 16.0219C13.3289 16.3814 12.8414 16.5833 12.333 16.5833H8.16638C7.65805 16.5833 7.17054 16.3814 6.81109 16.0219C6.46176 15.6726 6.2612 15.2023 6.25019 14.7095L5.48896 7.24939H5C4.58579 7.24939 4.25 6.9136 4.25 6.49939C4.25 6.08518 4.58579 5.74939 5 5.74939H6.16667H7.16638ZM7.91638 7.24996H12.583H13.5026L12.7536 14.5905C12.751 14.6158 12.7497 14.6412 12.7497 14.6666C12.7497 14.7771 12.7058 14.8831 12.6277 14.9613C12.5495 15.0394 12.4436 15.0833 12.333 15.0833H8.16638C8.05588 15.0833 7.94989 15.0394 7.87175 14.9613C7.79361 14.8831 7.74972 14.7771 7.74972 14.6666C7.74972 14.6412 7.74842 14.6158 7.74584 14.5905L6.99681 7.24996H7.91638Z"
                                clipRule="evenodd"
                                fillRule="evenodd"
                              />
                            </svg>
                            <span className="tooltiptext">remove</span>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ))
              ) : (
                <h2 className="empty-cart">
                  {t("No Items In Your Wishing List !")}
                </h2>
              )}
            </div>
          </div>
        </div>
      </Container>
      <Container>
        <Row>
          <Col xs={0} md={4} lg={5}></Col>
          <Col xs={12} md={4} lg={2}>
            <div className="my-3">
              <button
                className="shopping-back"
                onClick={() => navigate("/profile")}
              >
                {t("back")}
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default WishList;
